/**
 * Goal Proposals (objectif proposition) — coaches only.
 * Coach / Expert Coach; dual-role users with a coach role qualify.
 * Admin / Super Admin / Player without a coach role do not.
 */
export function canAccessGoalProposals(user) {
  if (!user) return false;

  if (user.hasCoachRole === true) return true;
  if (user.type_user_id === 3) return true;

  const names = user.all_role_names;
  if (Array.isArray(names)) {
    if (names.includes("Coach") || names.includes("Expert Coach")) return true;
  }

  const roles = user.all_roles;
  if (Array.isArray(roles)) {
    if (roles.includes("r3") || roles.includes("r5")) return true;
  }

  return false;
}
